module.exports = __webpack_public_path__ + "static/media/temp_28.6f665dec.jpg";